import {useAppContext} from "../utils/AppContext";
import {support_en} from "../assets/texts/en";
import Footer from "../components/home/Footer";

const Terms = () => {
    const {
        screenSize,
    } = useAppContext();

    const contentContainer = (!screenSize)? "content-container" : `content-container content-container${screenSize}`;
    const supportScroll = (!screenSize)? "support-pages-scroll" : `support-pages-scroll support-pages-scroll${screenSize}`;
    const termsContainer = (!screenSize)? "terms-container" : `terms-container terms-container${screenSize}`;
    const sectionTitle = (!screenSize)? 'section-title' : `section-title section-title${screenSize}`;
    const supportPageHeader = (!screenSize)? 'support-page-header' : `support-page-header support-page-header${screenSize}`;
    const supportItemContainer = (!screenSize)? 'support-item-container' : `support-item-container support-item-container${screenSize}`;
    const itemTitle = (!screenSize)? 'item-title' : `item-title item-title${screenSize}`;
    const smallTextLight = (!screenSize)? 'small-text-light' : `small-text-light small-text-light${screenSize}`;
    const footerItemsContainer = (!screenSize)? "footer-items-container" : `footer-items-container footer-items-container${screenSize}`;

    return (
        <div className={contentContainer}>
            <div className={supportScroll}>
                <div className={termsContainer}>
                    <div className={supportPageHeader}>
                        <h2 className={sectionTitle}>{support_en.terms.title}</h2>
                        <span className={smallTextLight}>{support_en.terms.date}</span>
                    </div>
                    <div className={supportItemContainer}>
                        <p className={smallTextLight}>Welcome to Maze. These Terms of Service ("Terms") govern your use of our website and app ("Services"). By accessing or using our Services, you ("you" or "User") agree to be bound by these Terms. If you disagree with any part of the Terms, then you may not access or use the Services.
                        </p>
                    </div>
                    <div className={supportItemContainer}>
                        <h2 className={itemTitle}>1. Services</h2>
                        <p className={smallTextLight}>Maze provides an app that generates copywriting for SaaS landing pages. Maze also provides website services such as chat conversations and personalized content. We may modify, suspend, or discontinue the Services at any time without notice. We do not warrant the accuracy, completeness, or usefulness of any content provided through the Services.
                        </p>
                    </div> 
                    <div className={supportItemContainer}> 
                        <h2 className={itemTitle}>2. User Accounts</h2>
                        <p className={smallTextLight}>To access certain features of the Services, you may be required to create an account. You are responsible for maintaining the confidentiality of your account information and for all activity that occurs under your account. You agree to provide accurate and complete information when creating an account.
                        </p>
                    </div>
                    <div className={supportItemContainer}>
                        <h2 className={itemTitle}>3. User Content</h2>
                        <p className={smallTextLight}>You retain all ownership rights to any content you submit to the Services. By submitting content, you grant Maze a non-exclusive license to use, reproduce, modify, adapt, publish, translate, distribute, and display such content in connection with the Services.
                        </p>
                    </div>
                    <div className={supportItemContainer}>
                        <h2 className={itemTitle}>4. Prohibited Conduct</h2>
                        <p className={smallTextLight}>You agree not to: <br/>
                            • Use the Services for any illegal or unauthorized purpose. <br/>
                            • Interfere with or disrupt the integrity or performance of the Services. <br/>
                            • Attempt to gain unauthorized access to the Services or related systems or networks. <br/>
                            • Use the Services to transmit any harmful content, including viruses, malware, or other destructive code. <br/>
                            • Engage in any activity that violates the privacy or intellectual property rights of others. <br/>
                            • Perform attacks or attempt to overload the service.
                        </p>
                    </div>
                    <div className={supportItemContainer}>
                        <h2 className={itemTitle}>5. Termination</h2>
                        <p className={smallTextLight}>We may terminate your access to the Services for any reason, at any time, without notice. We may also remove any content you have submitted to the Services.
                        </p>
                    </div>
                    <div className={supportItemContainer}>
                        <h2 className={itemTitle}>6. Disclaimer of Warranties</h2>
                        <p className={smallTextLight}>THE SERVICES ARE PROVIDED "AS IS" AND WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE DO NOT WARRANT THAT THE SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE.
                        </p>
                    </div>
                    <div className={supportItemContainer}>
                        <h2 className={itemTitle}>7. Limitation of Liability</h2>
                        <p className={smallTextLight}>TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE WILL NOT BE LIABLE FOR ANY DAMAGES ARISING OUT OF OR RELATED TO YOUR USE OF THE SERVICES, INCLUDING, BUT NOT LIMITED TO, DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, OR PUNITIVE DAMAGES.
                        </p>
                    </div>
                    <div className={supportItemContainer}>
                        <h2 className={itemTitle}>8. Governing Law</h2>
                        <p className={smallTextLight}>These Terms shall be governed and construed in accordance with the laws of the Dominican Republic, without regard to its conflict of law provisions.
                        </p>
                    </div>
                    <div className={supportItemContainer}>
                        <h2 className={itemTitle}>9. Entire Agreement</h2>
                        <p className={smallTextLight}>These Terms constitute the entire agreement between you and Maze relating to your use of the Services.
                        </p>
                    </div>
                    <div className={supportItemContainer}>
                        <h2 className={itemTitle}>10. Contact Us</h2>
                        <p className={smallTextLight}>If you have any questions about these Terms, please contact us at hello@maze.do or through the chat assistant.</p>
                    </div>
                </div>
                <div className={footerItemsContainer}>
                    <Footer/>
                </div>
            </div>
        </div>
    );

};

export default Terms;
